var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"groupHeadline"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.headline)+" ")]),(_vm.textDescription)?_c('div',{staticClass:"font-italic"},[_vm._v(" "+_vm._s(_vm.textDescription)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }